import * as React from "react";

import AppButton from "../components/UI/button";

import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useGetTestOnQueueDetailsQuery } from "../store/rtk-query/testQueueApi";

import { LabAllFormValuesInterface as AllFormValuesInterface } from "../@types/app-types";
import { useAttendToPatientMutation } from "../store/rtk-query/labResult";
import LabTests from "../components/LabTests";

import _ from "lodash";
import { formatServerErrorMessage } from "../utils/functions";
import { RenderSalesRecordContent } from "../components/modals/exportSalesRecord";
import TestRequestModal from "../components/modals/TestRequested";
import { ViewTestRequested } from "../components/modals/viewTestRequested";

const AttendToPatient = () => {
  const { queue_id } = useParams();
  const navigate = useNavigate();
  const [showPrintModal, setShowPrintModal] = React.useState<boolean>(false);

  const { data: testOnQueueData } = useGetTestOnQueueDetailsQuery({
    testId: queue_id,
  });

  const [attendToPx, attendToPxState] = useAttendToPatientMutation();

  const [allResultsEntered, setAllResultsEntered] =
    React.useState<boolean>(false);

  const [allFormValues, setAllFormValues] = React.useState<
    AllFormValuesInterface | undefined
  >(undefined);
  const [submitError, setSubmitError] = React.useState<string | undefined>(
    undefined
  );

  let initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  };

  console.log("allFormValues ", allFormValues);

  const classNames = (...classes: any) => {
    return classes.filter(Boolean).join(" ");
  };

  const onSubmit = async (e: any) => {
    e.preventDefault();

    if (!allFormValues) {
      toast.error("Please enter all required results before proceeding", {
        position: "top-right",
        autoClose: 5000,
      });
      return;
    }

    if (Object.keys(allFormValues).length == 0) {
      toast.error("Please enter all required results before proceeding", {
        position: "top-right",
        autoClose: 5000,
      });
      return;
    }

    if (!allResultsEntered) {
      toast.error("Please enter all required results before proceeding", {
        position: "top-right",
        autoClose: 5000,
      });
      setSubmitError("Please select YES before proceeding");
      return;
    }
    setSubmitError(undefined);

    let data = {
      ...allFormValues,
    };

    //convert all objects to arrays of 1 object
    let newData: any = {};

    const skipKeys: (keyof AllFormValuesInterface)[] = [
      "histologyTest",
      "gynaecologicCytology",
      "nongynaecologicCytology",
    ];

    for (let key in data) {
      const keyResult = data[key as keyof AllFormValuesInterface];
      if (Array.isArray(keyResult)) {
        newData[key] = keyResult;
      } else {
        if (!skipKeys.some((skipKey) => skipKey == key)) {
          newData[key] = [keyResult];
        } else {
          newData[key] = keyResult;
        }
      }
    }
    newData["makeAllResultAvailable"] = true;

    newData = _.omitBy(newData, _.isNil);

    console.log("data ", newData);

    // return
    //
    const res: any = await attendToPx({
      body: newData,
      testQueueId: testOnQueueData?.id,
    });

    if (res?.error) {
      let message = formatServerErrorMessage(res?.error?.data?.message);

      if (message.length > 0) {
        toast.error(message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
      return;
    }

    toast.success("Results submitted successfully");
    navigate("/reminders/waiting-queue");
  };

  const inputWrap = "flex justify-between md:justify-start gap-4";
  const inputClasses =
    "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5";
  const labelClasses = `block mb-1 text-sm font-medium text-gray-900 `;
  const radioClasses =
    "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600";

  const renderPatientInfo = () => {
    return (
      <div className="w-1/2 p-3 sm:p-4 md:p-6 bg-white border border-gray-200 rounded-lg shadow-md mr-2">
        <div className="font-semibold text-lg">Patient Information</div>
        <div className={inputWrap}>
          <div className="w-1/2">
            <label className={labelClasses}>Patient Name</label>
            <input
              className={inputClasses}
              disabled
              value={`${testOnQueueData?.patientName}`}
            />
          </div>
          <div className="w-1/2">
            <label className={labelClasses}>Patient REG Number</label>
            <input
              className={inputClasses}
              disabled
              defaultValue={testOnQueueData?.patientRegNumber}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderTestInfo = () => {
    return (
      <div className=" w-1/2 p-3 sm:p-4 md:p-6 bg-white border border-gray-200 rounded-lg shadow-md">
        <div className="font-semibold text-lg">Test Information</div>

        <div className={inputWrap}>
          <div className="flex p-2">
            <AppButton
              buttontype="outline"
              onClick={() => setShowPrintModal(true)}
              title="View Tests Requested"
            />
          </div>
          <div className="flex p-2">
            <AppButton
              buttontype="outline"
              onClick={() => setShowPrintModal(true)}
              title="Print results"
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="space-y-3">
      <div className="w-full z-30 bg-white shadow-md mb-1">
        <h3 className="text-lg my-3 p-3  font-semibold font-sans">
          Attend to Patient
        </h3>
      </div>
      <div className="flex justify-between">
        {renderPatientInfo()}
        {renderTestInfo()}
      </div>

      <LabTests
        onSubmit={onSubmit}
        isLoading={attendToPxState.isLoading}
        laboratoryTests={testOnQueueData?.laboratoryTests}
        onUpdateForms={setAllFormValues}
        setAllResultsEntered={setAllResultsEntered}
        submitError={submitError}
        isUpdateMode={false}
      />
      <TestRequestModal
        show={showPrintModal}
        onClose={() => setShowPrintModal(false)}
        content={() => {
          return <ViewTestRequested data={testOnQueueData} />;
        }}
      />
    </div>
  );
};

export default AttendToPatient;
